import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-chip px-3 py-1.5 text-caption font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'border border-border-strong bg-bg-primary text-text-secondary',
        accent: 'bg-accent text-bg-primary',
        success: 'bg-success/10 text-success border border-success/20',
        error: 'bg-error text-bg-primary',
        outline: 'border border-accent text-accent',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
